import { Link } from 'react-router-dom';
import Logo from '../assets/logo.png';

export default function Header() {
    return (
      <header className="sticky top-0 z-20 border-b border-slate-200/80 bg-white/90 backdrop-blur">
          <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
              <Link to="/">
                  <img src={Logo} alt="Prism Puzzles" className="h-12 w-auto sm:h-14" />
              </Link>
                <nav className="flex flex-wrap items-center gap-3 text-[13px] font-medium text-slate-700 sm:gap-4 sm:text-sm">
                    <Link to="/" className="transition hover:text-brand-cyan">Home</Link>
                    <Link to="/books" className="transition hover:text-brand-cyan">Books</Link>
                    <Link to="/solver" className="transition hover:text-brand-cyan">Solvers</Link>
                    <a href="/printable/" className="transition hover:text-brand-cyan">Free Printables</a>
                </nav>
            </div>
        </header>
    );
}
